import { useEffect } from 'react'
import { Box } from '@mui/material'
import colors from 'styles/colors'
import { RTVIEvent } from '@pipecat-ai/client-js'
import {
  RTVIClientAudio,
  RTVIClientProvider,
  VoiceVisualizer
} from '@pipecat-ai/client-react'

const RolePlayCallVoiceVisualizer = ({
  client,
  isBotReady,
  setIsBotReady,
  isBotSpeaking,
  setIsBotSpeaking
}) => {
  const handleBotReady = () => {
    setIsBotReady(true)
  }
  const handleBotSpeaking = () => {
    setIsBotSpeaking(true)
  }
  const handleBotStoppedSpeaking = () => {
    setIsBotSpeaking(false)
  }
  useEffect(() => {
    if (client) {
      client.on(RTVIEvent.BotReady, handleBotReady)
      client.on(RTVIEvent.BotStartedSpeaking, handleBotSpeaking)
      client.on(RTVIEvent.BotStoppedSpeaking, handleBotStoppedSpeaking)

      // Clean up event listeners on component unmount
      return () => {
        setIsBotReady(false)
        client?.off(RTVIEvent.BotReady, handleBotReady)
        client?.off(RTVIEvent.BotStartedSpeaking, handleBotSpeaking)
        client?.off(RTVIEvent.BotStoppedSpeaking, handleBotStoppedSpeaking)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client])

  return (
    <>
      {client && isBotReady && (
        <Box style={{ marginTop: 20 }}>
          <RTVIClientProvider client={client}>
            <RTVIClientAudio />
            <VoiceVisualizer
              participantType={isBotSpeaking ? 'bot' : 'local'}
              barColor={
                isBotSpeaking ? colors.GoldenYellow100 : colors.MutedTeal300
              }
              barMaxHeight={30}
              barWidth={4}
              barGap={8}
            />
          </RTVIClientProvider>
        </Box>
      )}
    </>
  )
}

export default RolePlayCallVoiceVisualizer
